import { User } from '@domain/user';

export const SHARED_REPORT_TOKEN_QUERY_PARAM = 'sharedReportToken';

export interface UserContextValue {
  userState: User | null;
  isUserLoading: boolean;
  setUserState: (user: User | null) => void;
  setIsUserLoading: (value: boolean) => void;
}
